import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import getNextIncrementValue from '../../thunks/general/getNextIncrementValue';
import getCoOrders from '../../thunks/coilovers/orders/getCoOrders';
import Modal from '../Modal/Modal';
import CreateOrderStepper from '../CreateOrderStepper/CreateOrderStepper';

const CoOrderNewOrderModal = ({ visible, toggleVisible }) => {
  const dispatch = useDispatch();
  const {
    getNextIncrementValue: {
      co_order_id: coOrderId
    },
    postCoOrder: {
      order_id: orderId
    } = {}
  } = useSelector((state) => ({
    getNextIncrementValue: state.getNextIncrementValue.data,
    postCoOrder: state.postCoOrder.data
  }), shallowEqual);

  useEffect(() => {
    if (visible) {
      dispatch(getNextIncrementValue('co_order_id'));
    }
  }, [visible]);

  useEffect(() => {
    if (orderId) {
      toggleVisible();
      dispatch(getCoOrders());
    }
  }, [orderId]);

  return (
    <>
      <Modal
        visible={visible}
        toggleVisible={() => {
          toggleVisible();
        }}
        title="New Order"
        subTitle={`Order id: ${coOrderId}`}
        showFooter={false}
      >
        <div className="customScroll w-[1100px]">
          <CreateOrderStepper />
        </div>
      </Modal>
    </>
  );
};

CoOrderNewOrderModal.propTypes = {
  toggleVisible: PropTypes.func,
  visible: PropTypes.bool,
};

CoOrderNewOrderModal.defaultProps = {
  toggleVisible: () => {},
  visible: false,
};

export default CoOrderNewOrderModal;
